import './StepNav.scss';

import React from 'react';
import { useTenant } from '../../context/TenantContext';
import { isMobile } from 'react-device-detect';

import logo from '../../img/logo.svg';
import meliLogo from '../../img/meli-logo.svg';

const StepNav = ({ steps, currentStep, totalSteps }) => {
  const { isMeliTenant } = useTenant();

  return (
    <>
      {isMobile ? (
        <>
          <div className={isMeliTenant ? 'step-nav-meli-mobile' : 'step-nav-mobile'}>
            {isMeliTenant && <img src={meliLogo} alt="Meli Logo" className="meli-logo" />}
            <img src={logo} alt="Logo" />
          </div>
          <div className="step-container">
            <span>
              Paso {currentStep} de {totalSteps}
            </span>
            <div className="step-indicator">
              <div className="grey-bar" />
              <div
                className={`blue-bar${isMeliTenant ? ' blue-bar-meli' : ''}`}
                style={{ width: `${(currentStep / totalSteps) * 100}%` }}
              />
            </div>
          </div>
        </>
      ) : (
        <ul className={`step-nav${isMeliTenant ? '' : ' w-200'}`}>
          {isMeliTenant ? (
            <div className="step-nav-logos mr-20">
              {isMeliTenant && <img src={meliLogo} alt="Meli Logo" className="meli-logo" />}
              <img src={logo} alt="Logo" />
            </div>
          ) : (
            <img src={logo} alt="Logo" />
          )}
          {steps.map((step) => (
            <li key={step.id} className={step.id === currentStep ? 'active' : ''}>
              <span className={`step-circle ${step.id === currentStep ? 'active' : ''}`}>
                {step.id}
              </span>
              <span className="step-label">{step.label}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default StepNav;
